import { AssignmentPage } from "app-configs/routesConfig";
import Plan from "containers/assignment/Plan";
import Result from "containers/assignment/Result";
import { withTranslation } from "i18n";
import { useRouter } from "next/router";
import React, { useEffect, useRef } from "react";
import { Nav } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage } from "redux/assignment/assignment.actions";
import { selectCurrentPage, selectIsFetchingAssignments, selectIsFetchingResults } from "redux/assignment/assignment.selectors";
import { assignmentString, stringFiles } from "res/strings";
import { createStructuredSelector } from "reselect";

export const TabsType = {
  assignments: 0,
  results: 1,
}


const Assignment = ({ t }) => {


  const dispatch = useDispatch();
  const router = useRouter();


  const {
    currentPage,
    isFetchingAssignments,
    isFetchingResults
  } = useSelector(
    createStructuredSelector({
      currentPage: selectCurrentPage,
      isFetchingAssignments: selectIsFetchingAssignments,
      isFetchingResults: selectIsFetchingResults,

    })
  );


  return (
    <>

      <Nav activeKey={currentPage || TabsType.assignments} variant="tabs" style={{
        height: 'fit-content', top: "3em",
        zIndex: "10"
      }}
        className="w-100 bg-light position-fixed justify-content-center customTab">
        <Nav.Item onClick={() => dispatch(setCurrentPage(TabsType.assignments))}>
          <Nav.Link className="customTabItem" eventKey={TabsType.assignments}>{t(assignmentString.planTab)}</Nav.Link>
        </Nav.Item>
        <Nav.Item onClick={() => dispatch(setCurrentPage(TabsType.results))}>
          <Nav.Link className="customTabItem" eventKey={TabsType.results}>{t(assignmentString.resultTab)}</Nav.Link>
        </Nav.Item>
      </Nav>
      <div style={{ top: "2em", position: "relative" }}>
        <div>
          {currentPage === TabsType.results ? <Result /> : <Plan />}

        </div>
      </div>

    </>
  )
};

Assignment.config = AssignmentPage;



export default withTranslation(stringFiles.common)(Assignment);
